import { useQueryClient } from '@tanstack/react-query';
import { logInfo } from 'app/services/logger';
import { ostroAdapter, StorageMode } from 'app/services/ostroAdapter';
import { useEffect } from 'react';

export function useSessionIdChange() {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (ostroAdapter.getStorageMode() === StorageMode.Persistent) {
      return;
    }

    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<{ sessionId: string }>;
      const newSessionId = customEvent.detail.sessionId;
      logInfo('Session ID changed:', newSessionId);

      // Invalidate all queries if the session ID changes
      queryClient.invalidateQueries();
    };

    window.addEventListener('ostro:sessionIdChanged', handler);

    return () => {
      window.removeEventListener('ostro:sessionIdChanged', handler);
    };
  }, [queryClient]);
}
